// @ts-nocheck
export const localeCodes =  [
  "cs",
  "en",
  "de",
  "fr"
]
export const localeLoaders = {
  cs: [
    {
      key: "locale_about_46cs_46ts_18044ffb",
      load: () => import("#nuxt-i18n/18044ffb" /* webpackChunkName: "locale_about_46cs_46ts_18044ffb" */),
      cache: true
    },
    {
      key: "locale_designers_46cs_46ts_c84cbf63",
      load: () => import("#nuxt-i18n/c84cbf63" /* webpackChunkName: "locale_designers_46cs_46ts_c84cbf63" */),
      cache: true
    },
    {
      key: "locale_homepage_46cs_46ts_84c2f44d",
      load: () => import("#nuxt-i18n/84c2f44d" /* webpackChunkName: "locale_homepage_46cs_46ts_84c2f44d" */),
      cache: true
    },
    {
      key: "locale_cookies_46cs_46ts_5132a42a",
      load: () => import("#nuxt-i18n/5132a42a" /* webpackChunkName: "locale_cookies_46cs_46ts_5132a42a" */),
      cache: true
    },
    {
      key: "locale_sustainability_46cs_46ts_1cd4c3ab",
      load: () => import("#nuxt-i18n/1cd4c3ab" /* webpackChunkName: "locale_sustainability_46cs_46ts_1cd4c3ab" */),
      cache: true
    },
    {
      key: "locale_baseCommon_46ts_4e4d773d",
      load: () => import("#nuxt-i18n/4e4d773d" /* webpackChunkName: "locale_baseCommon_46ts_4e4d773d" */),
      cache: true
    },
    {
      key: "locale_base_46cs_46ts_01f5b4c5",
      load: () => import("#nuxt-i18n/01f5b4c5" /* webpackChunkName: "locale_base_46cs_46ts_01f5b4c5" */),
      cache: true
    },
    {
      key: "locale_pages_46cs_46ts_bbd14b6e",
      load: () => import("#nuxt-i18n/bbd14b6e" /* webpackChunkName: "locale_pages_46cs_46ts_bbd14b6e" */),
      cache: true
    },
    {
      key: "locale_signup_46cs_46ts_90913909",
      load: () => import("#nuxt-i18n/90913909" /* webpackChunkName: "locale_signup_46cs_46ts_90913909" */),
      cache: true
    },
    {
      key: "locale_user_46cs_46ts_84a655b2",
      load: () => import("#nuxt-i18n/84a655b2" /* webpackChunkName: "locale_user_46cs_46ts_84a655b2" */),
      cache: true
    },
    {
      key: "locale_aboutCompany_46cs_46ts_75288c3a",
      load: () => import("#nuxt-i18n/75288c3a" /* webpackChunkName: "locale_aboutCompany_46cs_46ts_75288c3a" */),
      cache: true
    },
    {
      key: "locale_forCustomers_46cs_46ts_5b1afa59",
      load: () => import("#nuxt-i18n/5b1afa59" /* webpackChunkName: "locale_forCustomers_46cs_46ts_5b1afa59" */),
      cache: true
    },
    {
      key: "locale_emails_46cs_46ts_55a03402",
      load: () => import("#nuxt-i18n/55a03402" /* webpackChunkName: "locale_emails_46cs_46ts_55a03402" */),
      cache: true
    },
    {
      key: "locale_countries_46cs_46ts_39b2de34",
      load: () => import("#nuxt-i18n/39b2de34" /* webpackChunkName: "locale_countries_46cs_46ts_39b2de34" */),
      cache: true
    },
    {
      key: "locale_breadcrumb_46cs_46ts_86f41c20",
      load: () => import("#nuxt-i18n/86f41c20" /* webpackChunkName: "locale_breadcrumb_46cs_46ts_86f41c20" */),
      cache: true
    },
    {
      key: "locale_error_46cs_46ts_420822fe",
      load: () => import("#nuxt-i18n/420822fe" /* webpackChunkName: "locale_error_46cs_46ts_420822fe" */),
      cache: true
    },
    {
      key: "locale_configurator_46cs_46ts_c62c9022",
      load: () => import("#nuxt-i18n/c62c9022" /* webpackChunkName: "locale_configurator_46cs_46ts_c62c9022" */),
      cache: true
    },
    {
      key: "locale_euSupport_46cs_46ts_ae83a01a",
      load: () => import("#nuxt-i18n/ae83a01a" /* webpackChunkName: "locale_euSupport_46cs_46ts_ae83a01a" */),
      cache: true
    },
    {
      key: "locale_productline_46cs_46ts_a400bf34",
      load: () => import("#nuxt-i18n/a400bf34" /* webpackChunkName: "locale_productline_46cs_46ts_a400bf34" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_about_46en_46ts_2a94f4dd",
      load: () => import("#nuxt-i18n/2a94f4dd" /* webpackChunkName: "locale_about_46en_46ts_2a94f4dd" */),
      cache: true
    },
    {
      key: "locale_designers_46en_46ts_34e1b279",
      load: () => import("#nuxt-i18n/34e1b279" /* webpackChunkName: "locale_designers_46en_46ts_34e1b279" */),
      cache: true
    },
    {
      key: "locale_homepage_46en_46ts_c64c1c42",
      load: () => import("#nuxt-i18n/c64c1c42" /* webpackChunkName: "locale_homepage_46en_46ts_c64c1c42" */),
      cache: true
    },
    {
      key: "locale_cookies_46en_46ts_3980c872",
      load: () => import("#nuxt-i18n/3980c872" /* webpackChunkName: "locale_cookies_46en_46ts_3980c872" */),
      cache: true
    },
    {
      key: "locale_sustainability_46en_46ts_beea0c58",
      load: () => import("#nuxt-i18n/beea0c58" /* webpackChunkName: "locale_sustainability_46en_46ts_beea0c58" */),
      cache: true
    },
    {
      key: "locale_baseCommon_46ts_4e4d773d",
      load: () => import("#nuxt-i18n/4e4d773d" /* webpackChunkName: "locale_baseCommon_46ts_4e4d773d" */),
      cache: true
    },
    {
      key: "locale_base_46en_46ts_b1eed909",
      load: () => import("#nuxt-i18n/b1eed909" /* webpackChunkName: "locale_base_46en_46ts_b1eed909" */),
      cache: true
    },
    {
      key: "locale_pages_46en_46ts_cdcb3d91",
      load: () => import("#nuxt-i18n/cdcb3d91" /* webpackChunkName: "locale_pages_46en_46ts_cdcb3d91" */),
      cache: true
    },
    {
      key: "locale_signup_46en_46ts_677cea3d",
      load: () => import("#nuxt-i18n/677cea3d" /* webpackChunkName: "locale_signup_46en_46ts_677cea3d" */),
      cache: true
    },
    {
      key: "locale_user_46en_46ts_e5537618",
      load: () => import("#nuxt-i18n/e5537618" /* webpackChunkName: "locale_user_46en_46ts_e5537618" */),
      cache: true
    },
    {
      key: "locale_aboutCompany_46en_46ts_a73b5b60",
      load: () => import("#nuxt-i18n/a73b5b60" /* webpackChunkName: "locale_aboutCompany_46en_46ts_a73b5b60" */),
      cache: true
    },
    {
      key: "locale_forCustomers_46en_46ts_84607d78",
      load: () => import("#nuxt-i18n/84607d78" /* webpackChunkName: "locale_forCustomers_46en_46ts_84607d78" */),
      cache: true
    },
    {
      key: "locale_emails_46en_46ts_df41d0ac",
      load: () => import("#nuxt-i18n/df41d0ac" /* webpackChunkName: "locale_emails_46en_46ts_df41d0ac" */),
      cache: true
    },
    {
      key: "locale_countries_46en_46ts_b88d8407",
      load: () => import("#nuxt-i18n/b88d8407" /* webpackChunkName: "locale_countries_46en_46ts_b88d8407" */),
      cache: true
    },
    {
      key: "locale_breadcrumb_46en_46ts_3a1e2526",
      load: () => import("#nuxt-i18n/3a1e2526" /* webpackChunkName: "locale_breadcrumb_46en_46ts_3a1e2526" */),
      cache: true
    },
    {
      key: "locale_error_46en_46ts_837270e7",
      load: () => import("#nuxt-i18n/837270e7" /* webpackChunkName: "locale_error_46en_46ts_837270e7" */),
      cache: true
    },
    {
      key: "locale_configurator_46en_46ts_a36e72b7",
      load: () => import("#nuxt-i18n/a36e72b7" /* webpackChunkName: "locale_configurator_46en_46ts_a36e72b7" */),
      cache: true
    },
    {
      key: "locale_euSupport_46en_46ts_6de4d758",
      load: () => import("#nuxt-i18n/6de4d758" /* webpackChunkName: "locale_euSupport_46en_46ts_6de4d758" */),
      cache: true
    },
    {
      key: "locale_productline_46en_46ts_1ab47973",
      load: () => import("#nuxt-i18n/1ab47973" /* webpackChunkName: "locale_productline_46en_46ts_1ab47973" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_about_46de_46ts_ab97f0b1",
      load: () => import("#nuxt-i18n/ab97f0b1" /* webpackChunkName: "locale_about_46de_46ts_ab97f0b1" */),
      cache: true
    },
    {
      key: "locale_designers_46de_46ts_844dfc22",
      load: () => import("#nuxt-i18n/844dfc22" /* webpackChunkName: "locale_designers_46de_46ts_844dfc22" */),
      cache: true
    },
    {
      key: "locale_homepage_46de_46ts_d5ec7492",
      load: () => import("#nuxt-i18n/d5ec7492" /* webpackChunkName: "locale_homepage_46de_46ts_d5ec7492" */),
      cache: true
    },
    {
      key: "locale_cookies_46de_46ts_f0ed499a",
      load: () => import("#nuxt-i18n/f0ed499a" /* webpackChunkName: "locale_cookies_46de_46ts_f0ed499a" */),
      cache: true
    },
    {
      key: "locale_sustainability_46de_46ts_fb4513ae",
      load: () => import("#nuxt-i18n/fb4513ae" /* webpackChunkName: "locale_sustainability_46de_46ts_fb4513ae" */),
      cache: true
    },
    {
      key: "locale_baseCommon_46ts_4e4d773d",
      load: () => import("#nuxt-i18n/4e4d773d" /* webpackChunkName: "locale_baseCommon_46ts_4e4d773d" */),
      cache: true
    },
    {
      key: "locale_base_46de_46ts_c2a2fa46",
      load: () => import("#nuxt-i18n/c2a2fa46" /* webpackChunkName: "locale_base_46de_46ts_c2a2fa46" */),
      cache: true
    },
    {
      key: "locale_pages_46de_46ts_d8193f85",
      load: () => import("#nuxt-i18n/d8193f85" /* webpackChunkName: "locale_pages_46de_46ts_d8193f85" */),
      cache: true
    },
    {
      key: "locale_signup_46de_46ts_3680cab4",
      load: () => import("#nuxt-i18n/3680cab4" /* webpackChunkName: "locale_signup_46de_46ts_3680cab4" */),
      cache: true
    },
    {
      key: "locale_user_46de_46ts_d6252ab9",
      load: () => import("#nuxt-i18n/d6252ab9" /* webpackChunkName: "locale_user_46de_46ts_d6252ab9" */),
      cache: true
    },
    {
      key: "locale_aboutCompany_46de_46ts_bd3e8cf5",
      load: () => import("#nuxt-i18n/bd3e8cf5" /* webpackChunkName: "locale_aboutCompany_46de_46ts_bd3e8cf5" */),
      cache: true
    },
    {
      key: "locale_forCustomers_46de_46ts_98eaf82b",
      load: () => import("#nuxt-i18n/98eaf82b" /* webpackChunkName: "locale_forCustomers_46de_46ts_98eaf82b" */),
      cache: true
    },
    {
      key: "locale_emails_46de_46ts_b5c4c146",
      load: () => import("#nuxt-i18n/b5c4c146" /* webpackChunkName: "locale_emails_46de_46ts_b5c4c146" */),
      cache: true
    },
    {
      key: "locale_countries_46de_46ts_ccefc2bf",
      load: () => import("#nuxt-i18n/ccefc2bf" /* webpackChunkName: "locale_countries_46de_46ts_ccefc2bf" */),
      cache: true
    },
    {
      key: "locale_breadcrumb_46de_46ts_91f1dcbf",
      load: () => import("#nuxt-i18n/91f1dcbf" /* webpackChunkName: "locale_breadcrumb_46de_46ts_91f1dcbf" */),
      cache: true
    },
    {
      key: "locale_error_46de_46ts_34211205",
      load: () => import("#nuxt-i18n/34211205" /* webpackChunkName: "locale_error_46de_46ts_34211205" */),
      cache: true
    },
    {
      key: "locale_configurator_46de_46ts_cee4323e",
      load: () => import("#nuxt-i18n/cee4323e" /* webpackChunkName: "locale_configurator_46de_46ts_cee4323e" */),
      cache: true
    },
    {
      key: "locale_euSupport_46de_46ts_617d2f1e",
      load: () => import("#nuxt-i18n/617d2f1e" /* webpackChunkName: "locale_euSupport_46de_46ts_617d2f1e" */),
      cache: true
    },
    {
      key: "locale_productline_46de_46ts_b8a1f0c6",
      load: () => import("#nuxt-i18n/b8a1f0c6" /* webpackChunkName: "locale_productline_46de_46ts_b8a1f0c6" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_about_46fr_46ts_7025507a",
      load: () => import("#nuxt-i18n/7025507a" /* webpackChunkName: "locale_about_46fr_46ts_7025507a" */),
      cache: true
    },
    {
      key: "locale_designers_46fr_46ts_fadc425a",
      load: () => import("#nuxt-i18n/fadc425a" /* webpackChunkName: "locale_designers_46fr_46ts_fadc425a" */),
      cache: true
    },
    {
      key: "locale_homepage_46fr_46ts_627c7afc",
      load: () => import("#nuxt-i18n/627c7afc" /* webpackChunkName: "locale_homepage_46fr_46ts_627c7afc" */),
      cache: true
    },
    {
      key: "locale_cookies_46fr_46ts_6e4f94b8",
      load: () => import("#nuxt-i18n/6e4f94b8" /* webpackChunkName: "locale_cookies_46fr_46ts_6e4f94b8" */),
      cache: true
    },
    {
      key: "locale_sustainability_46fr_46ts_8e010e26",
      load: () => import("#nuxt-i18n/8e010e26" /* webpackChunkName: "locale_sustainability_46fr_46ts_8e010e26" */),
      cache: true
    },
    {
      key: "locale_baseCommon_46ts_4e4d773d",
      load: () => import("#nuxt-i18n/4e4d773d" /* webpackChunkName: "locale_baseCommon_46ts_4e4d773d" */),
      cache: true
    },
    {
      key: "locale_base_46fr_46ts_1318780d",
      load: () => import("#nuxt-i18n/1318780d" /* webpackChunkName: "locale_base_46fr_46ts_1318780d" */),
      cache: true
    },
    {
      key: "locale_pages_46fr_46ts_cd9e0734",
      load: () => import("#nuxt-i18n/cd9e0734" /* webpackChunkName: "locale_pages_46fr_46ts_cd9e0734" */),
      cache: true
    },
    {
      key: "locale_signup_46fr_46ts_4ded4b1e",
      load: () => import("#nuxt-i18n/4ded4b1e" /* webpackChunkName: "locale_signup_46fr_46ts_4ded4b1e" */),
      cache: true
    },
    {
      key: "locale_user_46fr_46ts_98dc8ebb",
      load: () => import("#nuxt-i18n/98dc8ebb" /* webpackChunkName: "locale_user_46fr_46ts_98dc8ebb" */),
      cache: true
    },
    {
      key: "locale_aboutCompany_46fr_46ts_e9db72a7",
      load: () => import("#nuxt-i18n/e9db72a7" /* webpackChunkName: "locale_aboutCompany_46fr_46ts_e9db72a7" */),
      cache: true
    },
    {
      key: "locale_forCustomers_46fr_46ts_7e471162",
      load: () => import("#nuxt-i18n/7e471162" /* webpackChunkName: "locale_forCustomers_46fr_46ts_7e471162" */),
      cache: true
    },
    {
      key: "locale_emails_46fr_46ts_06272c66",
      load: () => import("#nuxt-i18n/06272c66" /* webpackChunkName: "locale_emails_46fr_46ts_06272c66" */),
      cache: true
    },
    {
      key: "locale_countries_46fr_46ts_9db89a2e",
      load: () => import("#nuxt-i18n/9db89a2e" /* webpackChunkName: "locale_countries_46fr_46ts_9db89a2e" */),
      cache: true
    },
    {
      key: "locale_breadcrumb_46fr_46ts_4f3a47c3",
      load: () => import("#nuxt-i18n/4f3a47c3" /* webpackChunkName: "locale_breadcrumb_46fr_46ts_4f3a47c3" */),
      cache: true
    },
    {
      key: "locale_error_46fr_46ts_24bb9dbe",
      load: () => import("#nuxt-i18n/24bb9dbe" /* webpackChunkName: "locale_error_46fr_46ts_24bb9dbe" */),
      cache: true
    },
    {
      key: "locale_configurator_46fr_46ts_2687b912",
      load: () => import("#nuxt-i18n/2687b912" /* webpackChunkName: "locale_configurator_46fr_46ts_2687b912" */),
      cache: true
    },
    {
      key: "locale_euSupport_46fr_46ts_6067e8d7",
      load: () => import("#nuxt-i18n/6067e8d7" /* webpackChunkName: "locale_euSupport_46fr_46ts_6067e8d7" */),
      cache: true
    },
    {
      key: "locale_productline_46fr_46ts_90dca57b",
      load: () => import("#nuxt-i18n/90dca57b" /* webpackChunkName: "locale_productline_46fr_46ts_90dca57b" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/533f2824" /* webpackChunkName: "config_i18n_46config_46ts_533f2824" */)
]
export const normalizedLocales = [
  {
    code: "cs",
    language: "cs",
    name: "Čeština",
    _hreflang: "cs",
    _sitemap: "cs"
  },
  {
    code: "en",
    language: "en",
    name: "English",
    _hreflang: "en",
    _sitemap: "en"
  },
  {
    code: "de",
    language: "de",
    name: "Deutsch",
    _hreflang: "de",
    _sitemap: "de"
  },
  {
    code: "fr",
    language: "fr",
    name: "Français",
    _hreflang: "fr",
    _sitemap: "fr"
  }
]
/** client **/

/** client-end **/